import axios from "axios";
import { API_URL } from "config";
import { getToken } from "utils/getToken";

export const getEmployeesImportTemplate = ({ churchId }) => {
  return axios.get(`${API_URL}/churches/${churchId}/employees-template`, {
    headers: {
      Authorization: getToken()
    },
    responseType: "blob"
  });
};
